import { CEUserAttributesBase } from './ce-user-attributes-base'


export class CEUserAttributes extends CEUserAttributesBase {

}